/* global URLSearchParams */
/* no-unused-vars */
/* camelcase,no-undef */
import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { toast } from "react-toastify";
// --- 1. Import withRouter ---
import { withRouter } from "react-router-dom";
import {
  Layout,
  Container,
  RequestContainer,
  RequestText,
  RequestCardWrapper,
  RequestCard,
  MainSectionView2,
  ViewContainerV2,
  FilterIcon1,
  StyledInputV2,
  SearchFilter1,
  BuddyTabContainer,
  BuddyTab1,
  Heading,
  ManageButton,
} from "./styles";
import { PaginationCircleNew } from "../Journeys/styles";
import { UserButton } from "../EngagementSection/styles";
import PeopleListView from "../PeopleListViewV2/communityListView";
import PeopleGridView from "../PeopleGridViewV2/communityGridView";
import Waiting from "../Waiting";
import NewEmployeePopup from "../NewEmployeePopupV2";
import CSVMaker from "../CSVMaker";
import CSVList from "../../components/PeopleHomeV2/CSVList";

import NewFilterPopup from "../common/CommonDeptLoc/NewFilterPopup";
import {
  RemoveCSVData,
  FetchEmployeeCount,
  DeleteEmployeeAPI,
  FetchSetRemoveAPI,
  PostAddEmployee,
  getListOfEmployees,
  getSortedEmployees,
  uploadBiometricForm,
  viewPhysicianFormAPI,
  getUserRoles,
  getCompanyDetails,
  getFriendRequests,
  acceptOrRejectFriendRequest,
  getWellnessInterests,
  getCompanyLocation,
} from "../../redux/actions";
import ReactPDF from "../../components/ReactPDF";
import { fetchApi, getPermissionStatus } from "../../utils/methods";

import RolesNavigation, { ROLE_TYPES } from "./RolesNavigation";

const AddRolesPopup = React.lazy(() => import("../AddRolesPopup"));
const EditUserDetailsPopup = React.lazy(() => import("./EditUserDetailsPopup"));
import { withTranslation } from "react-i18next";
import { ImageUrl } from "../../utils/constants";
import {
  editDepartmentApi,
  editLocationApi,
  fetchPeopleAdminAccess,
  sendFriendRequest,
} from "../../redux/actions/peopleHomeActions";

const AddLocationPopup = React.lazy(() =>
  import("../NewEmployeePopupV2/locationPopup")
);
const AddDepartmentPopup = React.lazy(() =>
  import("../NewEmployeePopupV2/departmentPopup")
);
const ParticipantDepartmentPopup = React.lazy(() =>
  import("../NewEmployeePopupV2/participantsDepartment")
);
import {
  FieldTitleV2,
  StyledBodyV2,
  StyledHeader,
  StyledmodalV2,
  PopupHeaderNew,
} from "../NewEmployeePopupV2/styles";
import {
  AddEmployeeIcon,
  UpdateDepartmentIcon,
  UpdateLocationIcon,
  DownloadIcon,
  NewFilterIcon,
  DeleteChallengeIcon
} from "../../utils/icons";
import { GetPeoplePageReport } from "../../redux/constants/apiConstants";
import RemoveEmployee from "../NewEmployeePopupV2/removeEmployee";
import HoverButton from "../common/HoverButtonV2";

const WAIT_INTERVAL = 1500;
const ENTER_KEY = 13;

const userType = [
  { name: "All Users", id: 0 },
  { name: "Employee", id: 1 },
  { name: "Spouse", id: 2 },
  { name: "Dependent", id: 3 },
];

const headers = [
  { label: "First Name", key: "fname" },
  { label: "Last Name", key: "lname" },
  { label: "Email", key: "mail" },
  { label: "Department", key: "department" },
  { label: "Location", key: "location" },
  { label: "Birthday", key: "birthday" },
  { label: "Work Anniversary", key: "work_anniversary" },
  { label: "Team", key: "team_name" },
  { label: "Manager", key: "manager_name" },
  { label: "Gender", key: "gender" },
  { label: "Status", key: "user_status" },
];

class PeoplePage extends Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(props.history?.location?.search);
    const urlRole = params.get("role");
    const isRoleTabActive = params.get("tab") === "roles";

    this.state = {
      selectedEmployee: null,
      department: null,
      departmentId: null,
      engagement: "",
      alphabetical: null,
      alphabeticalId: "",
      search: "",
      showPopUp: false,
      showGrid: props.showView,
      companyId: props.companyInfo["id"],
      engagementSort: false,
      showSort: false,
      pageNo: 1,
      loading: false,
      minLimit: 1,
      maxLimit: "",
      total: "",
      countingValues: "",
      locationDropDown: null,
      locationDropDownId: "",
      loader: false,
      showPDFModal: false,
      buttonText: "",
      pdfBase64: "",
      uploadUid: null,
      showDeleteUserPopUp: false,
      selectUserDropDown: "All Users",
      selectUserDropDownId: 0,
      showRolesPopup: false,
      showUserPopUp: false,
      wellnessInterest: null,
      wellnessInterestId: "",
      userId: null,
      initiativeId: null,
      initiativeName: null,
      wellnessSearch: false,
      peoplePage: null,
      peoplePageId: "",
      showLocation: false,
      showDepartment: false,
      participantLocation: false,
      participantDepartment: false,
      activeButton: false,
      selectedParticipant: [],
      showNote: false,
      NoteText: "Location",
      showTeams: false,
      redirectToTop: false,
      welcomePopUp: false,
      isDropdownOpen: false,
      activeSubTab: "",
      timeInterval: "Monthly",
      popupMode: "Manual",
      peoplePageReportData: null,
      isRolesTab: isRoleTabActive || false,
      selectedRole: urlRole ? urlRole : ROLE_TYPES[0].value,
    };
    this.timer = null;
  }

  onEnterMouse = (uid, id, name) => {
    this.setState({
      userId: uid,
      initiativeId: id,
      initiativeName: name,
    });
  };

  onLeaveMouse = () => {
    this.setState({
      userId: null,
      initiativeId: null,
    });
  };

  handleWelcomePopUp = (value) => {
    this.setState({ welcomePopUp: value });
  };

  UNSAFE_componentWillReceiveProps(prevProps) {
    const { paginationCount } = prevProps;
    if (paginationCount && this.state.countingValues !== paginationCount) {
      this.setState(
        {
          total: Math.ceil(paginationCount / 20),
          countingValues: paginationCount,
        },
        () => {
          if (this.state.total < 6) {
            this.setState({
              maxLimit: this.state.total,
            });
          } else {
            this.setState({
              maxLimit: 6,
            });
          }
        }
      );
    }
  }

  nextPageDetail = (e) => {
    e.preventDefault();
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (bottom) {
      this.setState(
        {
          pageNo: this.state.pageNo + 1,
        },
        () => {
          if (this.props.count > this.props.employeeData.length) {
            this.fetchEmployee();
          }
        }
      );
    }
  };

  componentDidMount() {
    this.props.fetchListOfEmployees();
    const {
      getCompanyDetails,
      fetchFriendRequests,
      getWellnessInterests,
      searchAmigo,
    } = this.props;
    this.fetchEmployee();
    const { companyId } = this.state;
    !searchAmigo && getCompanyDetails(companyId);
    searchAmigo && fetchFriendRequests();
    getWellnessInterests();
    getCompanyLocation(companyId, true);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.redirectToTop) {
      window.scrollTo(0, 0);
      window.setTimeout(() => {
        this.setState({ redirectToTop: false });
      }, 3000);
    }
    if (prevState.companyId !== this.state.companyId) {
      this.setState(
        {
          search: "",
          pageNo: 1,
          engagementSort: false,
          showSort: false,
          department: null,
          departmentId: null,
          alphabetical: null,
          alphabeticalId: "",
          activeButton: false,
          selectedParticipant: [],
        },
        () => {
          this.fetchEmployee();
        }
      );
    }

    
    const currentLocation = this.props.location || this.props.history.location;
    const prevLocation = prevProps.location || prevProps.history.location;

    if (currentLocation.search !== prevLocation.search) {
      const params = new URLSearchParams(currentLocation.search);
      const role = params.get("role");
      const tab = params.get("tab");

      
      if (role && role !== this.state.selectedRole) {
        this.setState({
          selectedRole: role,
          pageNo: 1,
          activeButton: false,
          selectedParticipant: []
        }, () => {
          this.fetchEmployee();
        });
      }

      
      if (tab === 'roles' && !this.state.isRolesTab) {
        this.setState({ isRolesTab: true }, () => this.fetchEmployee());
      } else if (tab !== 'roles' && this.state.isRolesTab) {
        this.setState({ isRolesTab: false, selectedRole: ROLE_TYPES[0].value }, () => this.fetchEmployee());
      }
    }
  }

  changeOrder = () => {
    this.setState(
      {
        engagementSort: !this.state.engagementSort,
        showSort: true,
        pageNo: 1,
        selectedEmployee: null,
        alphabetical: null,
      },
      () => {
        this.fetchEmployee();
      }
    );
  };

  setorRemoveAction = (uid, status) => {
    const { fetchSetRemoveAPI } = this.props;
    let obj = {};
    obj["uid"] = uid;
    obj["status"] = !status ? 1 : 0;
    obj["company_id"] = this.state.companyId;
    obj["role"] = 11;
    fetchSetRemoveAPI(obj);
  };

  onSearchFunction = () => {
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      this.fetchEmployee();
    }, WAIT_INTERVAL);
  };

  handleKeyDown = (evt) => {
    if (evt.keyCode === ENTER_KEY) {
      window.clearTimeout(this.timer);
      this.fetchEmployee();
    }
  };

  changeLoading = () => {
    this.setState({
      loading: false,
    });
  };

  fetchEmployee = () => {
    this.setState({
      uploadUid: null,
    });
    let obj = {};
    const {
      pageNo,
      companyId,
      search,
      engagementSort,
      showSort,
      alphabeticalId,
      departmentId,
      department,
      locationDropDown,
      locationDropDownId,
      selectUserDropDownId,
      wellnessInterest,
      wellnessSearch,
      peoplePageId,
      isRolesTab,
      selectedRole,
    } = this.state;
    const { fetchPeopleAdmin } = this.props;
    if (pageNo === 1) {
      this.setState({ loading: true });
    } else {
      this.changeLoading();
    }

    if (peoplePageId !== "") {
      if (peoplePageId !== "all") {
        obj["point_sort"] = peoplePageId;
      }
    }

    obj["company_id"] = companyId;
    obj["name"] = search && search.trim();

    if (isRolesTab) {
      obj["limit"] = 100;
      obj["page_no"] = 1;
      obj["role"] = selectedRole;
    } else {
      obj["limit"] = 20;
      obj["page_no"] = pageNo;
    }

    if (selectUserDropDownId === 0) {
      obj["user_type"] = "all";
    } else if (selectUserDropDownId === 1) {
      obj["user_type"] = 0;
    } else if (selectUserDropDownId === 2) {
      obj["user_type"] = 1;
    } else if (selectUserDropDownId === 3) {
      obj["user_type"] = 2;
    }

    if (wellnessInterest && wellnessSearch) {
      obj["interest_id"] = wellnessInterest;
    }

    if (showSort) {
      if (engagementSort) {
        obj["engagement_sort"] = "DESC";
      } else {
        obj["engagement_sort"] = "ASC";
      }
    } else {
      if (alphabeticalId === 1) {
        obj["name_sort"] = "ASC";
      } else if (alphabeticalId === 2) {
        obj["name_sort"] = "DESC";
      }
    }

    if (departmentId && department !== "All Department") {
      obj["department_id"] = departmentId;
    }

    if (locationDropDownId && locationDropDown !== "All Location") {
      obj["city_state_id"] = locationDropDownId;
    }

    fetchPeopleAdmin(obj, this.changeLoading);
    this.setState({
      selectedEmp: null,
      selectedEmployee: null,
    });
  };

  fetchEmployeePost = (uid) => {
    this.setState({
      uploadUid: null,
    });
    let obj = {};
    const {
      pageNo,
      companyId,
      search,
      engagementSort,
      showSort,
      alphabeticalId,
      departmentId,
      department,
      locationDropDown,
      locationDropDownId,
      selectUserDropDownId,
      isRolesTab,
      selectedRole,
    } = this.state;
    const { fetchEmployeeCount, sendFriendRequest } = this.props;

    obj["company_id"] = companyId;
    obj["name"] = search && search.trim();

    if (isRolesTab) {
      obj["limit"] = 10000;
      obj["page_no"] = 1;
      obj["role"] = selectedRole;
    } else {
      obj["limit"] = 20;
      obj["page_no"] = pageNo;
    }

    if (showSort) {
      if (engagementSort) {
        obj["engagement_sort"] = "DESC";
      } else {
        obj["engagement_sort"] = "ASC";
      }
    } else {
      if (alphabeticalId === 1) {
        obj["name_sort"] = "ASC";
      } else if (alphabeticalId === 2) {
        obj["name_sort"] = "DESC";
      }
    }

    if (selectUserDropDownId === 0) {
      obj["user_type"] = "all";
    } else if (selectUserDropDownId === 1) {
      obj["user_type"] = 0;
    } else if (selectUserDropDownId === 2) {
      obj["user_type"] = 1;
    } else if (selectUserDropDownId === 3) {
      obj["user_type"] = 2;
    }

    if (departmentId && department !== "All Department") {
      obj["department_id"] = departmentId;
    }

    if (locationDropDownId && locationDropDown !== "All Location") {
      obj["city_state_id"] = locationDropDownId;
    }

    if (
      pageNo === 1 &&
      !showSort &&
      search === "" &&
      !departmentId &&
      !alphabeticalId &&
      !locationDropDownId
    ) {
      fetchEmployeeCount(obj, false);
    } else {
      fetchEmployeeCount(obj, false);
    }
    sendFriendRequest(uid, obj);
  };

  deleteUserAction = (uid) => {
    const { deleteEmployeeAPI } = this.props;
    let obj = {};
    obj["user_uid"] = uid;
    deleteEmployeeAPI(obj);
    this.setState({
      selectedEmployee: null,
    });
  };

  getCompany = (value) => {
    if (!this.state.loading) {
      const { companies, setCompany } = this.props;
      const id = companies.filter(
        (company) => company.company_name === value
      )[0].id;
      this.setState({
        companyId: id,
        pageNo: 1,
        selectedEmployee: null,
        countingValues: "",
        minLimit: 1,
        maxLimit: "",
        departmentId: null,
        locationDropDownId: null,
        activeButton: false,
        selectedParticipant: [],
      });
      setCompany(id, value);
    }
  };

  updateLocationPopUp = () => {
    this.setState({
      showLocation: !this.state.showLocation,
    });
  };

  addParticipantsLocation = () => {
    let participant = JSON.parse(localStorage.getItem("selectedEmployeeList"));
    this.setState({
      participantLocation: !this.state.participantLocation,
      selectedParticipant: participant,
      activeButton: !this.state.activeButton,
    });
  };

  addParticipantsDepartment = () => {
    let participant = JSON.parse(localStorage.getItem("selectedEmployeeList"));
    this.setState({
      participantDepartment: !this.state.participantDepartment,
      selectedParticipant: participant,
    });
  };

  updateDepartmentPopUp = () => {
    this.setState({
      showDepartment: !this.state.showDepartment,
    });
  };

  userModal = () => {
    this.setState((prevState) => ({
      showUserPopUp: !prevState.showUserPopUp,
    }));
  };

  showEmployeeDetails = (id) => {
    if (!this.state.loading) {
      this.setState({
        selectedEmployee: id,
      });
    }
  };

  updateDropdown = (title, id, titleKey, idKey) => {
    this.setState(
      {
        [titleKey]: title,
        [idKey]: id,
        pageNo: 1,
        engagementSort: false,
        showSort: false,
      },
      () => {
        this.fetchEmployee();
      }
    );
  };

  updatePoints = (title, id, titleKey, idKey) => {
    this.setState(
      {
        [titleKey]: title,
        [idKey]: id,
      },
      () => {
        this.fetchEmployee();
      }
    );
  };

  updateWellnessDropdown = (title, id, titleKey, idKey) => {
    if (title != "All") {
      this.setState({
        wellnessSearch: true,
      });
    } else {
      this.setState({
        wellnessSearch: false,
      });
    }
    this.setState(
      {
        [titleKey]: title,
        [idKey]: id,
        pageNo: 1,
        engagementSort: false,
        showSort: false,
      },
      () => {
        this.fetchEmployee();
      }
    );
  };

  onSelect = (value, state) => {
    this.setState(
      {
        [state]: value,
      },
      () => {
        const { department, engagement, alphabetical, search } = this.state;
        this.sortEmployees(search, engagement, department, alphabetical);
      }
    );
  };

  onChange = (e) => {
    e.preventDefault();
    if (!this.state.loading) {
      this.setState(
        {
          search: e.target.value,
          pageNo: 1,
          engagementSort: false,
          showSort: false,
        },
        () => {
          this.onSearchFunction();
          const { department, engagement, alphabetical, search } = this.state;
          this.sortEmployees(search, engagement, department, alphabetical);
        }
      );
    }
  };

  sortEmployees = (search, engagement, department, alphabetical) => {
    this.props.fetchSortedEmployees(
      search,
      engagement,
      department,
      alphabetical
    );
  };

  showView = (value) => {
    this.setState({
      showGrid: value,
    });
  };

  getMenuItems = () => {
    const { companies } = this.props;
    return companies && companies.map((company) => company.company_name);
  };

  getPaginationCircle = () => {
    let circleButton = [];
    for (let i = this.state.minLimit; i <= this.state.maxLimit; i++) {
      circleButton.push(
        <PaginationCircleNew
          key={i}
          active={i == this.state.pageNo}
          onClick={() => this.setPagination(i)}
        >
          <div>{i}</div>
        </PaginationCircleNew>
      );
    }
    return circleButton;
  };

  setPagination = (activeIndex) => {
    this.setState({
      redirectToTop: true,
    });
    if (activeIndex !== this.state.pageNo) {
      if (this.state.total <= 6) {
        this.setState(
          {
            minLimit: 1,
            maxLimit: this.state.total,
            pageNo: activeIndex,
          },
          () => {
            this.fetchEmployee();
          }
        );
      } else {
        if (activeIndex === 1) {
          this.setState(
            {
              pageNo: activeIndex,
              maxLimit: 6,
              minLimit: 1,
            },
            () => {
              this.fetchEmployee();
            }
          );
        } else {
          if (activeIndex + 3 > this.state.total) {
            this.setState(
              {
                pageNo: activeIndex,
                maxLimit: this.state.total,
                minLimit: this.state.total - 4,
              },
              () => {
                this.fetchEmployee();
              }
            );
          } else {
            this.setState(
              {
                pageNo: activeIndex,
                maxLimit: activeIndex + 3,
                minLimit: activeIndex - 1,
              },
              () => {
                this.fetchEmployee();
              }
            );
          }
        }
      }
    }
  };

  changeLoader = (bool) => {
    this.setState({
      loader: bool,
    });
  };

  uploadPDFFile = (e, id) => {
    let file = e.target.files[0];
    if (file) {
      let fileArr = file.name.split(".");
      if (fileArr[fileArr.length - 1].toUpperCase() == "PDF") {
        if (file.size / 1000000 <= 10) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            this.setState({
              showPDFModal: true,
              pdfBase64: reader.result,
              buttonText: "Submit",
              uploadUid: id,
            });
          };
        } else {
          toast.error("Please select PDF file less than 10MB");
          this.changeLoader(false);
          document.getElementById("biometric-user-admin-file").value = "";
        }
      } else {
        toast.error("Please select PDF file");
        this.changeLoader(false);
        document.getElementById("biometric-user-admin-file").value = "";
      }
    } else {
      this.changeLoader(false);
      document.getElementById("biometric-user-admin-file").value = "";
    }
  };

  removePDF = () => {
    this.setState({
      showPDFModal: false,
      pdfBase64: "",
      buttonText: "",
      uploadUid: null,
    });
    document.getElementById("biometric-user-admin-file").value = "";
  };

  closePopup = () => {
    const { uploadUid, pdfBase64 } = this.state;
    if (pdfBase64.trim() != "" && uploadUid) {
      this.changeLoader(true);
      this.props.uploadBiometricForm(
        { physician_form: pdfBase64 },
        this.changeLoader,
        uploadUid,
        this.fetchEmployee
      );
      this.setState({
        showPDFModal: false,
      });
    }
  };

  showPDFData = (id) => {
    const { viewPhysicianFormAPI } = this.props;
    this.changeLoader(true);
    viewPhysicianFormAPI(id, this.changeLoader);
  };

  onToggleDeletePopup = () => {
    this.setState((prev) => ({
      showDeleteUserPopUp: !prev.showDeleteUserPopUp,
    }));
  };
  onToggleRolesPopup = (uid) => {
    this.setState(
      (prev) => ({ showRolesPopup: !prev.showRolesPopup }),
      () => {
        this.state.showRolesPopup && this.props.getUserRoles(uid);
      }
    );
  };

  acceptOrRejectRequest = (id, status) => {
    const { acceptOrRejectFriendRequest } = this.props;
    acceptOrRejectFriendRequest({ request_id: id, status: status });
  };

  fallBack = (e) => {
    e.target.src = "/public/images/default.png";
  };

  showManage = () => {
    const { history } = this.props;
    history.push("/community/manage-buddies");
  };

  showInternalText = () => (
    <FieldTitleV2
      paddingTop={1}
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        marginTop: "15px",
      }}
    >
      All The Employee added to your selected {this.state.NoteText}.
    </FieldTitleV2>
  );

  notePopup = () => (
    <StyledmodalV2 bulkWidth left show={this.state.showNote}>
      <StyledHeader closeButton>
        <PopupHeaderNew>
          <div className="headingTitle">Note</div>
          <div className="closeButton">
            <img
              src="/public/images/new_close_icon.png"
              alt=""
              style={{ cursor: "pointer", height: "20px", width: "20px" }}
              onClick={() => {
                this.handleShowNote("");
              }}
            />
          </div>
        </PopupHeaderNew>
      </StyledHeader>
      <StyledBodyV2>{this.showInternalText()}</StyledBodyV2>
    </StyledmodalV2>
  );

  handleShowNote = (text) => {
    this.setState({
      showNote: !this.state.showNote,
      NoteText: text,
    });
    this.fetchEmployee();
  };

  hideShowTeam = (status) => {
    const { history } = this.props;
    this.setState({ 
      showTeams: status,
      isRolesTab: false, 
      activeButton: false, 
      selectedParticipant: [],
    });
    if (status) {
      history.push("/company/people/team");
    }
  };

  hideShowInactiveUsers = (status) => {
    const { history } = this.props;
    this.setState({ 
      showTeams: status,
      isRolesTab: false, 
      activeButton: false, 
      selectedParticipant: [],
    });
    if (status) {
      history.push("/company/people/inactive-users");
    }
  };

  printAction = async (bool) => {
    const res = bool && await fetchApi(GetPeoplePageReport + "/" + this.props.companyInfo.id);
    if(bool){
      if(res.status === "success"){
        this.setState({
          peoplePageReportData: bool ? res?.data : null,
        },()=>{
          this.setState({
            printAttendees: bool,
          });
        });
      }
    }else{
      this.setState({
        printAttendees: bool,
      });
    }
  };

  setIsDropdownOpen = (value) => {
    this.setState({ isDropdownOpen: value });
  };
  openManualPopup = () => {
    this.setState({ showPopUp: true, popupMode: "manual" });
  };

  openBulkPopup = () => {
    this.setState({ showPopUp: true, popupMode: "bulk" });
  };

  closePopupWindow = () => {
    this.setState({ showPopUp: false });
  };

  // --- TAB HANDLERS ---
  handleActiveTabClick = () => {
    const { searchAmigo, history } = this.props;
    if (searchAmigo) return;

    if (this.state.isRolesTab || this.state.showTeams) {
      this.setState(
        {
          isRolesTab: false,
          showTeams: false, 
          activeButton: false, 
          selectedParticipant: [],
          pageNo: 1,
          search: "",
          selectedRole: ROLE_TYPES[0].value,
          selectUserDropDownId: 0, 
          selectUserDropDown: "All Users",
        },
        () => {
          this.fetchEmployee();
          // Reset URL to base path
          if(history) {
            history.push(history.location.pathname);
          }
        }
      );
    }
  };

  handleRolesTabClick = () => {
    const { searchAmigo, history } = this.props;
    if (searchAmigo) return;

    if (!this.state.isRolesTab) {
      const defaultRole = ROLE_TYPES[0].value;
      this.setState(
        {
          isRolesTab: true,
          showTeams: false, 
          activeButton: false, 
          selectedParticipant: [],
          selectedRole: defaultRole, 
          pageNo: 1,
          search: "",
          selectUserDropDownId: 0, 
          selectUserDropDown: "All Users",
        },
        () => {
          this.fetchEmployee();
          // Push State with URL query
          if(history) {
            history.push({
              pathname: history.location.pathname,
              search: `?tab=roles&role=${defaultRole}`
            });
          }
        }
      );
    }
  };
  handleRoleChange = (role) => {
    if (this.state.selectedRole !== role) {
      this.setState(
        {
          selectedRole: role,
          pageNo: 1,
          activeButton: false, 
          selectedParticipant: [],
        },
        () => {
          this.fetchEmployee();
        }
      );
      
      const { history } = this.props;
      if(history) {
        history.push({
          pathname: history.location.pathname,
          search: `?tab=roles&role=${role}`
        });
      }
    }
  };


  hasRolesPermission = () => {
    const { allRoles, searchAmigo } = this.props;
    return !searchAmigo && allRoles && allRoles.length > 0;
  };

  render() {
    // ... existing render logic ...
    const {
      employeeList,
      companyInfo,
      employeeData,
      downloadCSV,
      csvData,
      removeCSVData,
      paginationCount,
      searchAmigo,
      userRolesList,
      count,
      companyDetails,
      friendRequests,
      wellnessInterests,
      history,
      t,
      role,
      userCompany,
      allRoles,
    } = this.props;
    const {
      selectedEmployee,
      showPopUp,
      loader,
      showPDFModal,
      pdfBase64,
      buttonText,
      showRolesPopup,
      showUserPopUp,
      userId,
      initiativeId,
      initiativeName,
      showLocation,
      showDepartment,
      participantLocation,
      activeButton,
      participantDepartment,
      showTeams,
      printAttendees,
      popupMode,
      showRemoveEmployee,
      isRolesTab,
      selectedRole,
    } = this.state;

    if (
      _.isUndefined(employeeList) ||
      _.isNull(employeeList) ||
      !employeeData ||
      _.isUndefined(friendRequests) ||
      _.isUndefined(wellnessInterests)
    ) {
      return <Waiting />;
    }

    let selectedEmp = false;
    let selectedEmployeeDetail = false;
    if (
      !_.isUndefined(employeeData) &&
      !_.isNull(employeeData) &&
      employeeData.length > 0
    ) {
      selectedEmp = selectedEmployee ? selectedEmployee : employeeData[0].uid;
      selectedEmployeeDetail = employeeData.filter(
        (employee) => employee.uid === selectedEmp
      );
    } else {
      selectedEmp = false;
    }
    let WellnessInterestAll = [];
    WellnessInterestAll = [{ name: "All Interests", id: "0" }];
    let WellnessInterests = [];
    if (
      wellnessInterests &&
      !_.isUndefined(wellnessInterests) &&
      !_.isNull(wellnessInterests) &&
      wellnessInterests.length > 0
    ) {
      WellnessInterests = [...WellnessInterestAll, ...wellnessInterests];
    }

    const hasAnyRole = allRoles?.some((data) =>
      [3, 11, 12].includes(data?.rid)
    );

    const shouldShowRolesTab = !searchAmigo;

    const displayCount = isRolesTab
      ? (employeeData ? employeeData.length : 0)
      : (count || 0);

    let activeUserText = t("Active Users");
    if (searchAmigo) {
      activeUserText = t("Buddies");
    } else if (isRolesTab) {
      const currentRoleObj = ROLE_TYPES.find((tab) => tab.value === selectedRole);
      const roleLabel = currentRoleObj ? currentRoleObj.label : "";
      activeUserText = `${t("Active")} ${t(roleLabel)}`;
    }

    return (
      <Layout>
        {loader && <Waiting />}
        <Container>
          {this.state.loading && <Waiting />}
          {
            <BuddyTabContainer
              show={activeButton}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flex: 2, 
                }}
              >
                <BuddyTab1
                  active={!showTeams && !isRolesTab}
                  style={{ width: "auto", padding: "0 10px", cursor: "pointer" }}
                  onClick={this.handleActiveTabClick}
                >
                  {searchAmigo ? t("Buddies") : t("Active")}
                </BuddyTab1>

                {!searchAmigo && hasAnyRole && (
                  <BuddyTab1
                    active={showTeams ? true : false}
                    onClick={() => this.hideShowInactiveUsers(true)}
                    style={{ width: "auto", padding: "0 15px" }}
                  >
                    {" "}
                    {t("Inactive")}
                  </BuddyTab1>
                )}

                {!searchAmigo &&
                (role === "ADMIN" ||
                  role === "WELLNESS_ADMIN" ||
                  role === "WELLNESS_CHAMPION" ||
                  (userCompany && userCompany.showTeam)) ? (
                    <BuddyTab1
                      active={showTeams ? true : false}
                      onClick={() => this.hideShowTeam(true)}
                      style={{ width: "auto", padding: "0 15px" }}
                    >
                      {" "}
                      {t("Teams")}
                    </BuddyTab1>
                  ) : null}

                {/* --- ROLES TAB --- */}
                {shouldShowRolesTab && (
                  <BuddyTab1
                    active={isRolesTab}
                    onClick={this.handleRolesTabClick}
                    style={{
                      width: "auto",
                      padding: "0 15px",
                      cursor: "pointer",
                    }}
                  >
                    {t("Roles")}
                  </BuddyTab1>
                )}
              </div>

              <div
                style={{
                  flex: 1, 
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <ViewContainerV2>
                  {!searchAmigo &&
                    this.props.departmentDetails &&
                    this.props.departmentDetails != "" &&
                    this.props.departmentDetails != null &&
                    this.props.departmentDetails.length > 0 && (
                    <HoverButton
                      onClick={this.updateDepartmentPopUp}
                      title={"Manage Departments"}
                      svgPath={UpdateDepartmentIcon()}
                      fillOpacity={1}
                      activeColor={"#DA6C74"}
                      inActiveColor={"#DA6C74"}
                      backgroundColor={"white"}
                      backgroundColorActive={"#DA6C74"}
                      width={"24px"}
                      height={"24px"}
                    />
                  )}
                  {!searchAmigo &&
                  this.props.locationDetails &&
                  this.props.locationDetails.length > 0 && (
                    <HoverButton
                      onClick={this.updateLocationPopUp}
                      title={"Manage Locations"}
                      svgPath={UpdateLocationIcon()}
                      fillOpacity={1}
                      activeColor={"#DA6C74"}
                      inActiveColor={"#DA6C74"}
                      backgroundColor={"white"}
                      backgroundColorActive={"#DA6C74"}
                      width={"24px"}
                      height={"24px"}
                    />
                  )}

                  {!searchAmigo &&
                  getPermissionStatus(
                    "Add Employee",
                    this.props.userPermissions
                  ) && (
                    <div style={{ marginRight: "10px" }}>
                      <HoverButton
                        onClick={this.openManualPopup}
                        title={"Add Employees"}
                        svgPath={AddEmployeeIcon()}
                        fillOpacity={1}
                        activeColor={"#DA6C74"}
                        inActiveColor={"#DA6C74"}
                        backgroundColor={"white"}
                        backgroundColorActive={"#DA6C74"}
                        width={"24px"}
                        height={"24px"}
                      />
                    </div>
                  )}
                  <div style={{ margin: "0 10px 0 0", cursor: "pointer" }}>
                    <HoverButton
                      title={"Download"}
                      onClick={() => this.printAction(true)}
                      marginLeft={"0px"}
                      fillOpacity={1}
                      activeColor={"#DA6C74"}
                      inActiveColor={"#DA6C74"}
                      backgroundColor={"white"}
                      backgroundColorActive={"#DA6C74"}
                      width={"24px"}
                      height={"24px"}
                      svgPath={<DownloadIcon />}
                    />
                  </div>

                  <div style={{ margin: "0 10px 0 0", cursor: "pointer" }}>
                    <HoverButton
                      title={this.props.t("Delete")}
                      width="20px"
                      height="20px"
                      svgPath={<DeleteChallengeIcon color={'#DA6C74'}/>} 
                      onClick={()=>this.setState({showRemoveEmployee:true})}
                      backgroundColor={"white"}
                      backgroundColorActive={"#DA6C74"}
                      marginLeft={"0px"}
                      activeSvgPath={<DeleteChallengeIcon color={"white"}/>}
                    />
                  </div>
                </ViewContainerV2>
              </div>
              {searchAmigo && (
                <ManageButton
                  width="125px"
                  height="40px"
                  onClick={() => this.showManage()}
                >
                  {t("Manage")}
                </ManageButton>
              )}
            </BuddyTabContainer>
          }

          {/* --- REPLACED: NEW COMPONENT IMPLEMENTATION --- */}
          {!searchAmigo && isRolesTab && (
            <RolesNavigation
              activeRole={selectedRole}
              onRoleChange={this.handleRoleChange}
              t={t}
            />
          )}

          <FilterIcon1>
            <div
              style={{
                color: " #184A61",
                fontFamily: "Lato",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
              }}
            >
              {displayCount} {activeUserText}
            </div>
            {!this.props.history.location.search && <div style={{ display: "flex", alignItems: "center" }}>
              <SearchFilter1 isMargin style={{ marginRight: "0px" }}>
                <StyledInputV2
                  type="text"
                  value={this.state.search}
                  placeholder={t("Search user, teams, etc")}
                  onChange={(e) => this.onChange(e)}
                  onKeyDown={this.handleKeyDown}
                />
              </SearchFilter1>
              <div
                className="compare"
                id="filterSection"
                style={{ position: "relative" }}
              >
                <HoverButton
                  title={"Filter"}
                  svgPath={<NewFilterIcon />}
                  activeColor={"#DA6C74"}
                  inActiveColor={"#DA6C74"}
                  backgroundColor={"none"}
                  backgroundColorActive={"#DA6C74"}
                  onClick={() =>
                    this.setState({ isDropdownOpen: !this.state.isDropdownOpen })
                  }
                  width={"22px"}
                  height={"22px"}
                  fillOpacity={1}
                />
                <NewFilterPopup
                  companyId={companyInfo?.id}
                  setIsDropdownOpen={this.setIsDropdownOpen}
                  isDropdownOpen={this.state.isDropdownOpen}
                  activeSubTab={this.state.activeSubTab}
                  updateDropdown={this.updateDropdown}
                  userType={userType}
                  WellnessInterests={WellnessInterests}
                  updateWellnessDropdown={this.updateWellnessDropdown}
                  filters={
                    isRolesTab
                      ? ["department", "location", "interest"]
                      : ["department", "location", "user", "interest"]
                  }
                  selectType={"single"}
                  page={"active"}
                  locationDetails={this.props.locationDetails}
                  departmentDetails={this.props.departmentDetails}
                  isActiveTab={!isRolesTab} 
                  isRolesTab={isRolesTab} 
                />
              </div>
            </div>}
          </FilterIcon1>

          {friendRequests && friendRequests.length > 0 && searchAmigo && (
            <RequestContainer background="white">
              <RequestText>{t("Buddy Requests Recieved")}</RequestText>
              <RequestCardWrapper>
                {friendRequests &&
                  friendRequests.length > 0 &&
                  friendRequests.map((request, index) => (
                    <RequestCard key={index}>
                      <div className="profile">
                        <img
                          onError={this.fallBack}
                          src={`${ImageUrl}/${request.profile_image}`}
                          alt={"Profile"}
                        />
                      </div>
                      <div className="info">
                        <div className="name">{t(request.fullname)}</div>
                        <div className="wellness-icon">
                          {request.wellness_interest &&
                            request.wellness_interest.length > 0 &&
                            request.wellness_interest.map(
                              (wellness, index) =>
                                index < 5 && (
                                  <div
                                    key={index}
                                    onMouseEnter={() =>
                                      this.onEnterMouse(
                                        request.id,
                                        wellness.interest_id,
                                        wellness.interest_name
                                      )
                                    }
                                    onMouseLeave={() => this.onLeaveMouse()}
                                  >
                                    <img
                                      src={`${ImageUrl}/${wellness.interest_icon}`}
                                    />
                                    {userId === request.id &&
                                      initiativeId === wellness.interest_id && (
                                      <div className="hover-card">
                                        <div> {t(initiativeName)}</div>
                                      </div>
                                    )}
                                  </div>
                                )
                            )}
                        </div>
                      </div>
                      <div className="last-card">
                        <div
                          className="confirm"
                          onClick={() =>
                            this.acceptOrRejectRequest(request.id, "Accepted")
                          }
                        >
                          {t("Confirm")}
                        </div>
                        <div
                          className="cancel"
                          onClick={() =>
                            this.acceptOrRejectRequest(request.id, "Rejected")
                          }
                        >
                          {t("Cancel")}
                        </div>
                      </div>
                    </RequestCard>
                  ))}
              </RequestCardWrapper>
            </RequestContainer>
          )}
          {searchAmigo && (
            <Heading>
              {t(
                "Connect with colleagues who share similar roles or wellness interests"
              )}
            </Heading>
          )}
          {
            <div style={{ width: "100%", display: "flex" }}>
              <MainSectionView2 isMargin={"0px"}>
                {this.state.showGrid ? (
                  <PeopleGridView
                    employeeList={employeeData}
                    showEmployeeDetails={this.showEmployeeDetails}
                    selectedEmployee={selectedEmp}
                    searchAmigo={searchAmigo}
                    sendFriendRequestPost={this.fetchEmployeePost}
                    history={history}
                    show={activeButton} 
                    isRolesView={isRolesTab}
                    plp={{
                      companyId: this.state.companyId,
                      fetchEditLocationApi: this.props.fetchEditLocationApi,
                      show: participantLocation,
                      data: this.props.locationDetails,
                      departmentData: this.props.departmentDetails,
                      showModalPopUp: this.addParticipantsLocation,
                      companyAuthDetails: companyDetails,
                      handleShowNote: this.handleShowNote,
                    }}
                  />
                ) : (
                  <PeopleListView
                    employeeList={employeeData}
                    showEmployeeDetails={this.showEmployeeDetails}
                    selectedEmployee={selectedEmp}
                    changeOrder={this.changeOrder}
                    searchAmigo={searchAmigo}
                    sendFriendRequestPost={this.fetchEmployeePost}
                    history={history}
                    show={activeButton} 
                    isRolesView={isRolesTab}
                    plp={{
                      companyId: this.state.companyId,
                      fetchEditLocationApi: this.props.fetchEditLocationApi,
                      show: participantLocation,
                      data: this.props.locationDetails,
                      departmentData: this.props.departmentDetails,
                      showModalPopUp: this.addParticipantsLocation,
                      companyAuthDetails: companyDetails,
                      handleShowNote: this.handleShowNote,
                    }}
                  />
                )}
                {!isRolesTab && paginationCount > 21 && (
                  <div className="pagination">
                    {this.state.pageNo > 1 && (
                      <UserButton
                        width="32px"
                        height="32px"
                        Align={1}
                        padding="4px"
                        float={1}
                        fontSize="18px"
                        bgColor="transparent"
                        isDisplay="flex"
                        isJustify="center"
                        isAlign="center"
                        capitalize={1}
                        onClick={() => this.setPagination(this.state.pageNo - 1)}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="14"
                            viewBox="0 0 8 14"
                            fill="none"
                          >
                            <path
                              d="M8 12.8951V1.10468C7.99913 0.896107 7.93642 0.692477 7.81982 0.51954C7.70322 0.346602 7.53796 0.212123 7.34494 0.133106C7.15191 0.0540895 6.93979 0.0340843 6.73539 0.0756197C6.531 0.117155 6.34351 0.218367 6.19663 0.366455L0.31195 6.25114C0.213103 6.34918 0.134647 6.46582 0.0811065 6.59433C0.0275657 6.72284 0 6.86068 0 6.9999C0 7.13912 0.0275657 7.27697 0.0811065 7.40548C0.134647 7.53399 0.213103 7.65063 0.31195 7.74867L6.19663 13.6334C6.34351 13.7814 6.531 13.8827 6.73539 13.9242C6.93979 13.9657 7.15191 13.9457 7.34494 13.8667C7.53796 13.7877 7.70322 13.6532 7.81982 13.4803C7.93642 13.3073 7.99913 13.1037 8 12.8951Z"
                              fill="#DA6C74"
                            />
                          </svg>
                        </div>
                      </UserButton>
                    )}
                    {this.getPaginationCircle()}
                    {this.state.pageNo != this.state.total && (
                      <UserButton
                        width="32px"
                        height="32px"
                        Align={1}
                        padding="4px"
                        fontSize="18px"
                        bgColor="transparent"
                        capitalize={1}
                        isDisplay="flex"
                        isJustify="center"
                        isAlign="center"
                        onClick={() => this.setPagination(this.state.pageNo + 1)}
                      >
                        <div
                          style={{
                            color: "#DA6C74",
                            textAlign: "center",
                            fontFamily: "Lato",
                            fontSize: "18px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "24px",
                          }}
                        ></div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="14"
                          viewBox="0 0 8 14"
                          fill="none"
                        >
                          <path
                            d="M0 1.10487L0 12.8953C0.000874519 13.1039 0.0635757 13.3075 0.180175 13.4805C0.296775 13.6534 0.462038 13.7879 0.655064 13.8669C0.848091 13.9459 1.06021 13.9659 1.26461 13.9244C1.469 13.8828 1.65649 13.7816 1.80337 13.6335L7.68805 7.74886C7.7869 7.65082 7.86535 7.53418 7.91889 7.40567C7.97243 7.27716 8 7.13932 8 7.0001C8 6.86088 7.97243 6.72303 7.91889 6.59452C7.86535 6.46601 7.7869 6.34937 7.68805 6.25133L1.80337 0.366647C1.65649 0.218558 1.469 0.117347 1.26461 0.075811C1.06021 0.0342753 0.848091 0.0542803 0.655064 0.133297C0.462038 0.212314 0.296775 0.346793 0.180175 0.519731C0.0635757 0.692668 0.000874519 0.896297 0 1.10487Z"
                            fill="#DA6C74"
                          />
                        </svg>
                      </UserButton>
                    )}
                  </div>
                )}
              </MainSectionView2>
            </div>
          }
        </Container>
        {!searchAmigo && (
          <NewEmployeePopup
            companyId={this.state.companyId}
            postAddEmployee={this.props.postAddEmployee}
            show={showPopUp}
            popupMode={popupMode}
            showModalPopUp={this.closePopupWindow}
            companyAuthDetails={companyDetails}
            onSwitchMode={(mode) => {
              this.setState({ showPopUp: true, popupMode: mode });
            }}
          />
        )}
        {!searchAmigo && showRemoveEmployee && (
          <RemoveEmployee
            companyId={this.state.companyId}
            postAddEmployee={this.props.postAddEmployee}
            show={showRemoveEmployee}
            popupMode={popupMode}
            showModalPopUp={()=>this.setState({showRemoveEmployee:false})}
            companyAuthDetails={companyDetails}
          />
        )}
        {!searchAmigo && showLocation && (
          <Suspense fallback={<Waiting />}>
            <AddLocationPopup
              companyId={this.state.companyId}
              fetchEditLocationApi={this.props.fetchEditLocationApi}
              show={showLocation}
              data={this.props.locationDetails}
              showModalPopUp={this.updateLocationPopUp}
              companyAuthDetails={companyDetails}
            />
          </Suspense>
        )}
        {!searchAmigo && showDepartment && (
          <Suspense fallback={<Waiting />}>
            <AddDepartmentPopup
              companyId={this.state.companyId}
              fetchEditDepartmentApi={this.props.fetchEditDepartmentApi}
              show={showDepartment}
              data={this.props.departmentDetails}
              showModalPopUp={this.updateDepartmentPopUp}
              companyAuthDetails={companyDetails}
            />
          </Suspense>
        )}

        {!searchAmigo && (
          <Suspense fallback={<Waiting />}>
            <ParticipantDepartmentPopup
              companyId={this.state.companyId}
              fetchEditDepartmentApi={this.props.fetchEditDepartmentApi}
              show={participantDepartment}
              data={this.props.departmentDetails}
              showModalPopUp={this.addParticipantsDepartment}
              selectedParticipant={this.state.selectedParticipant}
              companyAuthDetails={companyDetails}
            />
          </Suspense>
        )}
        <div>
          {printAttendees && (
            <CSVList
              Title={`People-Page-Report`}
              removeCSVData={this.printAction}
              data={this.state.peoplePageReportData}
              headers={headers}
            />
          )}
        </div>

        {downloadCSV && !_.isUndefined(csvData) && !_.isNull(csvData) && (
          <CSVMaker data={csvData} removeCSVData={removeCSVData} />
        )}
        <ReactPDF
          showModal={showPDFModal}
          closeModal={this.closePopup}
          pdfBase64={pdfBase64}
          buttonText={buttonText}
          employee={selectedEmployeeDetail[0]}
          removePDF={this.removePDF}
          showCrossMarker={true}
        />
        {showRolesPopup && (
          <Suspense fallback={<Waiting />}>
            {" "}
            <AddRolesPopup
              showModal={showRolesPopup}
              closeModal={this.onToggleRolesPopup}
              employee={selectedEmployeeDetail && selectedEmployeeDetail[0]}
              userRolesList={userRolesList}
              companyId={companyInfo.id}
            />
          </Suspense>
        )}
        {showUserPopUp ? (
          <Suspense fallback={<Waiting />}>
            <EditUserDetailsPopup
              showUserModal={showUserPopUp}
              onClose={this.userModal}
              employee={selectedEmployeeDetail && selectedEmployeeDetail[0]}
              locationDetails={this.props.locationDetails}
              departmentDetails={this.props.departmentDetails}
              fetchEmployee={this.fetchEmployee}
            />{" "}
          </Suspense>
        ) : null}
        {this.notePopup()}
      </Layout>
    );
  }
}

PeoplePage.defaultProps = {
  companyInfo: { id: 1, name: "" },
};

PeoplePage.propTypes = {
  fetchListOfEmployees: PropTypes.func.isRequired,
  employeeList: PropTypes.array,
  fetchSortedEmployees: PropTypes.func.isRequired,
  sortedList: PropTypes.array,
  history: PropTypes.object,
  employeeData: PropTypes.array,
  count: PropTypes.number,
  companyInfo: PropTypes.object,
  companies: PropTypes.array,
  fetchPeopleAdmin: PropTypes.func,
  postAddEmployee: PropTypes.func,
  fetchSetRemoveAPI: PropTypes.func,
  deleteEmployeeAPI: PropTypes.func,
  fetchEmployeeCount: PropTypes.func,
  setCompany: PropTypes.func,
  downloadCSV: PropTypes.bool,
  csvData: PropTypes.array,
  removeCSVData: PropTypes.func,
  locationDetails: PropTypes.array,
  departmentDetails: PropTypes.array,
  paginationCount: PropTypes.number,
  searchAmigo: PropTypes.bool,
  uploadBiometricForm: PropTypes.func,
  role: PropTypes.string,
  viewPhysicianFormAPI: PropTypes.func,
  biometricPdfFile: PropTypes.string,
  userPermissions: PropTypes.array,
  userRolesList: PropTypes.array,
  getUserRoles: PropTypes.func,
  getCompanyDetails: PropTypes.func,
  companyDetails: PropTypes.func,
  t: PropTypes.func,
  sendFriendRequest: PropTypes.func,
  fetchFriendRequests: PropTypes.func.isRequired,
  friendRequests: PropTypes.array,
  acceptOrRejectFriendRequest: PropTypes.func.isRequired,
  getWellnessInterests: PropTypes.func,
  wellnessInterests: PropTypes.array,
  showView: PropTypes.bool,
  fetchEditLocationApi: PropTypes.func,
  fetchEditDepartmentApi: PropTypes.func,
  userCompany: PropTypes.object,
  fetchCelebrationsDetails: PropTypes.func,
  timeInterval: PropTypes.string,
  allRoles: PropTypes.array,
  // Added location prop type which comes from withRouter
  location: PropTypes.object
};

const mapStateToProps = (state) => ({
  employeeList: state.peopleHome.employeeList,
  sortedList: state.peopleHome.sortedList,
  employeeData: state.peopleHome.employeeAdminData,
  count: state.peopleHome.count,
  downloadCSV: state.peopleHome.csvMake,
  csvData: state.peopleHome.csvData,
  locationDetails: state.companyDashboard.companyPeopleLocation,
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  paginationCount: state.peopleHome.paginationCount,
  biometricPdfFile: state.profileData.biometricPdfFile,
  userPermissions: state.profileData.userPermissions,
  userRolesList: state.peopleHome.userRolesList,
  companyDetails: state.peopleHome.companyDetails,
  sentRequest: state.social.sentRequest,
  friendRequests: state.social.friendRequests,
  wellnessInterests: state.register.wellnessInterests,
  userCompany: state.profileData.userCompany,
  allRoles: state.profileData.allRoles,
});

const mapDispatchToProps = (dispatch) => ({
  fetchListOfEmployees: () => dispatch(getListOfEmployees()),
  fetchSortedEmployees: (search, engagement, department, alphabetical) =>
    dispatch(getSortedEmployees(search, engagement, department, alphabetical)),
  fetchPeopleAdmin: (data, cb) => dispatch(fetchPeopleAdminAccess(data, cb)),
  postAddEmployee: (data) => dispatch(PostAddEmployee(data)),
  fetchSetRemoveAPI: (obj) => dispatch(FetchSetRemoveAPI(obj)),
  deleteEmployeeAPI: (obj) => dispatch(DeleteEmployeeAPI(obj)),
  fetchEmployeeCount: (obj, bool) => dispatch(FetchEmployeeCount(obj, bool)),
  removeCSVData: () => dispatch(RemoveCSVData()),
  uploadBiometricForm: (obj, cb, userId, fetchEmployee) =>
    dispatch(uploadBiometricForm(obj, cb, userId, fetchEmployee)),
  viewPhysicianFormAPI: (uid, cb) => dispatch(viewPhysicianFormAPI(uid, cb)),
  getUserRoles: (uid) => dispatch(getUserRoles(uid)),
  getCompanyDetails: (companyId) => dispatch(getCompanyDetails(companyId)),
  sendFriendRequest: (data, obj) => dispatch(sendFriendRequest(data, obj)),
  fetchFriendRequests: () => dispatch(getFriendRequests()),
  acceptOrRejectFriendRequest: (acceptData) =>
    dispatch(acceptOrRejectFriendRequest(acceptData)),
  getWellnessInterests: () => dispatch(getWellnessInterests()),
  fetchEditLocationApi: (data, deleteloc) =>
    dispatch(editLocationApi(data, deleteloc)),
  fetchEditDepartmentApi: (data, deletedept) =>
    dispatch(editDepartmentApi(data, deletedept)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(PeoplePage)));